export default {
  npm_package_version: "__APP_VERSION__",
};
